"use client";

import { useEffect } from "react";
import { GUIDE_PUBLIC_COPY } from "@/lib/virtualspace/guide/guide-public-copy";

/** Something broke while rendering a Localized Egypt page: say so in both languages and offer a retry. */
export default function GuideError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("[localized] page error", error.digest ?? error.message);
  }, [error]);
  const lang = typeof window !== "undefined" && new URLSearchParams(window.location.search).get("lang") === "ar" ? "ar" : "en";
  const copy = GUIDE_PUBLIC_COPY[lang];
  return (
    <div className="eg-guide" dir={lang === "ar" ? "rtl" : "ltr"} lang={lang}>
      <main className="eg-wrap" style={{ paddingBlock: "96px 120px", display: "flex", flexDirection: "column", gap: 20, maxWidth: 720 }}>
        <h1 className="eg-display" style={{ margin: 0, fontSize: "clamp(2.2rem, 5vw, 3.4rem)", lineHeight: 1.05 }}>
          {copy.errors.error}
        </h1>
        <p style={{ margin: 0, fontSize: 18, color: "var(--eg-text)" }}>{copy.errors.errorBody}</p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
          <button type="button" className="eg-button eg-button--primary" onClick={() => reset()}>
            {copy.errors.retry}
          </button>
          <a href={lang === "ar" ? "?lang=ar" : "/"} className="eg-button eg-button--ghost" onClick={(e) => {
            e.preventDefault();
            window.location.assign(window.location.pathname.replace(/\/egypt\/.*$/, "/egypt") + (lang === "ar" ? "?lang=ar" : ""));
          }}>
            {copy.errors.home}
          </a>
        </div>
      </main>
    </div>
  );
}
